module.exports = __webpack_public_path__ + "static/media/promo_bandas_sonoras.7e0e06fb.webp";